<div class="bg-app-global min-h-screen flex flex-col">
  <app-header *ngIf="showHeaderFooter"></app-header>
  <div id="render-div" style="min-height: 700px;" class="flex-grow">
    <router-outlet></router-outlet>
  </div>
  <app-footer *ngIf="showHeaderFooter"></app-footer>
</div>

<app-incoming-call></app-incoming-call>
<app-active-call></app-active-call>
